<template>
  <div class="msg-shortcut" :class="item && item.isSeen ? 'bg-white' : ''">
    <div class="row p-0 m-0">
      <div class="col-2 py-0">
        <div class="msg-shortcut-img">
          <img src="@/assets/icons/court.svg" />
        </div>
      </div>
      <div class="col-9 py-0">
        <div class="msg-shortcut-body">
          <p class="text-right mb-0">
            {{ item.title }}
            <span>
              {{ item.content }}
            </span>
          </p>
          <span class="date" v-if="item && item.sentTimeUTC">
            {{ convertUTC(item.sentTimeUTC) }}
          </span>
        </div>
      </div>
      <div class="col-1 py-0 text-start">
        <div>
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none "
            class="stop-toggler"
            no-caret
            id="dropdown-2"
          >
            <template #button-content> &mldr; </template>
            <b-dropdown-item @click="deleteItem(item)"
              >مسح الإشعار</b-dropdown-item
            >
            <b-dropdown-item
              @click="seeItem(item.notificationId)"
              v-if="item && !item.isSeen"
              >تحديد كمقروء</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertUTC } from "@/helpers/convertUTC.js";
import { seeOneNotification, deleteNotification } from "@/api/notifications";
export default {
  name: "NotificationItem",
  props: ["item"],
 data: () => {
    return {
      showSubMenuToggle: null,
    };
  },
  methods: {
    convertUTC(date) {
      let time = convertUTC(date);
      if (time.Day || time.Hours || time.Minutes) {
        return `
        منذ
        ${time.Day ? time.Day + " يوم " : ""}
        ${time.Hours ? time.Hours + " ساعة " : ""}
        ${time.Minutes ? time.Minutes + " دقيقة " : ""}
      `;
      } else {
        return "منذ لحظات";
      }
    },
    async seeItem(id) {
      let result = await seeOneNotification(id);
      if (result) {
        this.$emit("changeItemSeen", id);
      }
    },
    async deleteItem(item) {
      let payload = {
        ids: [item.notificationId],
      };
      let result = await deleteNotification(payload);
      if (result) {
        this.$emit("removeItem", item);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "_style.scss";
</style>
